if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // Products routed through the accessories step never post to the cart from
      // here — the accessories page adds them together with the chosen accessories.
      if (this.dataset.accessoriesStepUrl && this.startAccessoriesStep()) return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    // Returns false when the handoff can't be made, so the caller falls back to
    // adding the product to the cart directly.
    startAccessoriesStep() {
      const item = this.buildPendingItem();
      if (!item.id) return false;

      const pending = {
        item: item,
        display: this.buildPendingDisplay(item),
        // Only set when this product carries its own accessories: the step page
        // fetches this to replace the default grid with the product's own list.
        itemsUrl: this.dataset.accessoriesItemsUrl || null,
        returnUrl: window.location.pathname + window.location.search,
        createdAt: Date.now()
      };

      try {
        sessionStorage.setItem(ACCESSORIES_STEP_KEY, JSON.stringify(pending));
      } catch (error) {
        return false;
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      window.location.href = this.dataset.accessoriesStepUrl;
      return true;
    }

    buildPendingItem() {
      const item = { id: null, quantity: 1, properties: {} };

      new FormData(this.form).forEach((value, key) => {
        if (key === 'id') {
          item.id = value;
        } else if (key === 'quantity') {
          item.quantity = parseInt(value, 10) || 1;
        } else if (key === 'selling_plan' && value) {
          item.selling_plan = value;
        } else if (key.startsWith('properties[') && key.endsWith(']') && value !== '') {
          item.properties[key.slice('properties['.length, -1)] = value;
        }
      });

      if (Object.keys(item.properties).length === 0) delete item.properties;
      return item;
    }

    buildPendingDisplay(item) {
      const display = { quantity: item.quantity };
      const dataElement = this.querySelector('.accessories-step-data');
      if (!dataElement) return display;

      let data;
      try {
        data = JSON.parse(dataElement.textContent);
      } catch (error) {
        return display;
      }

      const variant = (data.variants || []).find((candidate) => String(candidate.id) === String(item.id));
      display.title = data.title;
      if (variant) {
        display.price = variant.price;
        display.image = variant.image;
        if (variant.title !== 'Default Title') display.variantTitle = variant.title;
      }
      return display;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
